import { Label, type LabelProps } from "@Light/components/system/Fieldset";
import { useScaffold } from "@Light/scaffold";
import clsx from "clsx";

export const FieldLabel = ({ className, ...props }: LabelProps) => {
  const scaffold = useScaffold();
  return (
    <Label
      className={clsx(
        "font-medium text-sm",
        scaffold.page.colors.text.secondary,
        className,
      )}
      {...props}
    />
  );
};
